(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-ingredients"] && !Shopify.designMode) return;
  try {
    window.addEventListener('alpine:init', () => {
    Alpine.data('ingredientsBanner', () => ({
      cartDrawer: null,
      loading: false,
      init() {
        this.cartDrawer = document.querySelector('cart-drawer');
      },
      async handleFormSubmit() {
        this.loading = true;
        const formData = new FormData(this.$refs.form);

        console.log(formData.get('id'));

        const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'post',
          body: formData,
        });

        if (res.ok) {
          console.log('added. update and show cart.');
          await this.cartDrawer.refresh();
          this.cartDrawer.open();
        }

        this.loading = false;
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

})();
